export default "__VITE_PUBLIC_ASSET__3ae45d95__"